/**
 * The line that says which catalog release a report was scored against and
 * when. Null when there is no release, so a report never claims one. The date
 * is the UTC day, so the screen and the PDF agree for every viewer.
 */
export function catalogStamp(i: { catalogReleaseVersion: number | null; asOf: string | null }): string | null {
  if (i.catalogReleaseVersion === null) return null;
  const base = `Scored against Catalog Release ${i.catalogReleaseVersion}`;
  const date = i.asOf ? new Date(i.asOf) : null;
  if (!date || Number.isNaN(date.getTime())) return base;
  const day = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
  return `${base}, as of ${day}`;
}
